/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import {
  Container,
  Navbar,
  NavDropdown,
  Nav,
  Button,
  Modal,
} from "react-bootstrap";

import logo from "../../logo.svg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useTranslation } from "react-i18next";

import { NavLink, Redirect, useHistory, useLocation } from "react-router-dom";

import classes from "./Header.module.css";

import {
  updateObject,
  API_URLS,
  getUserName,
  isAdvanced,
  checkDateForNotifications,
  logoutAndDeleteStorage,
  downloadUrl,
  isContributor,
  APP_URLS,
} from "../../shared/utility";
import useSettings from "../../hooks/useSettings";
import Star from "./Star/Star";
import graphQLClientInstance from "../../axios-graphql-client";
import { connect } from "react-redux";
import * as actions from "../../store/actions";
import { useAlert } from "../../shared/AlertService";
import AdviceStatusBadge from "../UI/AdviceStatusBadge/AdviceStatusBadge";
import CustomModal from "../UI/CustomModal/CustomModal";
import TestDataSheet from "../TestDataSheet/TestDataSheet";

const classAlignMiddle ="align-middle"
const classFloatRight = "float-right"
const Header: React.FC = (props: any) => {
  const { t, i18n } = useTranslation();

  const [, setCurrentLanguage] = useSettings(
    "i18nextLng",
    i18n.language
  );
  const [currentSearches, setCurrentSearches] = React.useState(<></>);
  const [notifications, setNotifications] = React.useState(<></>);
  const [modalState, setModalState] = React.useState(false);
  const [
    deleteSavedSearch,
    setDeleteSavedSearch,
  ] = React.useState<ISavedSearch | null>(null);

  const alert = useAlert();
  const [testModalState, setTestModalState] = React.useState(false);
  const [activeTestDataSheetId, setActiveTestDataSheetId] = React.useState(-1);

const [languages, setLanguages] = React.useState<JSX.Element[]>([]);

  React.useEffect(() => {
    let langJSON = {"en": "English"};
    try {
      const langString = process.env.REACT_APP_LANGUAGES;
      if (langString) {
        langJSON = JSON.parse(langString);
      }
    } catch { }

    Object.keys(langJSON).forEach((langKey: string, index: number) => {
      setLanguages(prevLangArray =>
        [
          ...prevLangArray,
          <NavDropdown.Item
            eventKey={`${index}`}
            key={index}
            onClick={() => changeLanguage(langKey)}
          >
            {/* @ts-ignore */}
            {langJSON?.[langKey]}
          </NavDropdown.Item>
        ]);
    });

    graphQLClientInstance.get(API_URLS.SEARCHES).then((res) => {
      const searches = res.data;
      props.onInitSavedSearches(searches.Items);
    }).catch((err) => console.log(err));
    if (isAdvanced()) {
      refreshNotifications();
    }
  }, []);

  const refreshNotifications = () => {
    graphQLClientInstance.get(API_URLS.NOTIFICATIONS).then((res) => {
      props.onInitNotifications(res.data);
    }).catch(err => console.log(err));
  }

  React.useEffect(() => {
    if (isAdvanced()) {
      const interval = setInterval(() => {
        if (checkDateForNotifications()) {
          refreshNotifications();
        } else {
          clearInterval(interval);
        }
      }, parseInt(process.env.REACT_APP_NOTIFICATION_INTERVAL!) * 1000);
      return () => clearInterval(interval);
    }
  }, []);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setCurrentLanguage(lng);
  };

  const deleteSearch = (savedSearch: ISavedSearch) => {
    setDeleteSavedSearch(savedSearch);
    setModalState(true);
  };

  const deleteSearchSubmit = () => {
    if (deleteSavedSearch) {
      graphQLClientInstance
        .delete(
          `${API_URLS.SEARCHES}/${deleteSavedSearch.datatype.replace(
            /#/g,
            "%"
          )}`
        )
        .then((res) => {
          props.onRemoveSavedSearch(deleteSavedSearch);
        });
    }
    setModalState(false);
  };

  const setDefaultSearch = (item: ISavedSearch) => {
    if (item.isDefault) {
      return;
    }

    const updatedItem = updateObject(item, { isDefault: true });

    graphQLClientInstance
      .patch(
        `${API_URLS.SEARCHES}/${updatedItem.datatype.replace(/#/g, "%")}`,
        updatedItem
      )
      .then((res) => {
        props.onSetDefaultSavedSearch(updatedItem);
      });
  };

  const [selectedSearch, setSelectedSearch] = React.useState<any>({});

  const selectSearch = (item: ISavedSearch) => {
    if (window.location.pathname !== APP_URLS.SEARCH_VARIETIES){
      setSelectedSearch(item);
    } else {
      props.onSelectSavedSearch(item);
    }
  };

  React.useEffect(() => {
    setCurrentSearches(
      props.savedSearches && props.savedSearches.length ? (
        props.savedSearches.map((search: ISavedSearch, i: number) => (
          <React.Fragment key={`savedSearch${i}`}>
            <div className={classes.customDropdownItem}>
              <Star
                active={search.isDefault}
                onClick={() => {
                  setDefaultSearch(search);
                  alert({
                    catchOnCancel: false,
                    title: t("info"),
                    body: t("new_default_search", {
                      defaultSearch: search.searchName,
                    }),
                  });
                }}
              />
              <div
                className="align-middle d-inline-block text-truncate"
                onClick={() => selectSearch(search)}
                style={{ width: "150px" }}
              >
                {search.searchName}
              </div>
              <FontAwesomeIcon
                onClick={() => deleteSearch(search)}
                icon={["fas", "trash-alt"]}
                className={[
                  classAlignMiddle,
                  classFloatRight ,
                  classes.userMenuIcon,
                ].join(" ")}
                style={{ margin: "0 12.5px" }}
                color="#000000"
              />
            </div>
            <NavDropdown.Divider />
          </React.Fragment>
        ))
      ) : (
        <div className={classes.noSavedSearches}>{t("no_saved_searches")}</div>
      )
    );
  }, [props.savedSearches]);

  React.useEffect(() => {
    setNotifications(
      props.notifications && props.notifications.length ? (
        props.notifications.map((notification: any, i: number) => (
          <React.Fragment key={`notification-${i}`}>
            <div
              className={classes.customDropdownItem}
              onClick={() => {
                setActiveTestDataSheetId(notification.testid);
                setTestModalState(true);
              }}
            >
              <div
                className="align-middle d-inline-block text-truncate"
                style={{
                  maxWidth: "200px",
                  marginLeft: "12.5px",
                  marginRight: "12.5px",
                }}
              >
                {notification.denomination}
              </div>
              <span className="float-right" style={{ margin: "0 12.5px" }}>
                <AdviceStatusBadge text={notification.test_status} />
              </span>
            </div>
            <NavDropdown.Divider />
          </React.Fragment>
        ))
      ) : (
        <div className={classes.noSavedSearches}>{t("no_notifications")}</div>
      )
    );
  }, [props.notifications]);

  const userName = getUserName();

  const downloadDatabase = () => {
    graphQLClientInstance.get(API_URLS.DOWNLOAD_DATABASE).then((res) => {
      if (res.data?.url) {
        downloadUrl(res.data?.url);
      } else {
        alert({
          title: t("alert"),
          body: t("generic_error")
        })
      }
    }).catch((err) => {
      alert({
        title: t("alert"),
        body: t("generic_error")
      });
    })
  }

  const history = useHistory();
  const contributor = isContributor();

  const location = useLocation();

  React.useEffect(() => {
    if (location?.pathname === APP_URLS.SEARCH_VARIETIES) {
      setSelectedSearch({});
    }
  }, [location]);

  return (
    <>
      <Container fluid className={classes.Header}>
        <Navbar expand="lg">
          <NavLink to={APP_URLS.SEARCH_VARIETIES}>
            <Navbar.Brand>
              <img
                src={logo}
                width="64"
                height="62"
                className="d-inline-block align-top"
                alt="CPVO Varity Finder"
              />
            </Navbar.Brand>
          </NavLink>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <NavLink
                className="nav-link"
                activeClassName="active"
                exact
                to={APP_URLS.SEARCH_VARIETIES}
              >
                {t("menu.main.search_varieties")}
              </NavLink>
              <NavLink
                className="nav-link"
                activeClassName="active"
                exact
                to="/denominations"
              >
                {t("menu.main.test_denomination")}
              </NavLink>
              {/* <NavLink className="nav-link" activeClassName="active" exact to="/denominations">{t("menu.main.test_denomination")}</NavLink> */}
              <NavLink
                className="nav-link"
                activeClassName="active"
                exact
                to="/species"
              >
                {t("menu.main.species")}
              </NavLink>
              <NavLink
                className="nav-link"
                activeClassName="active"
                exact
                to="/classes"
              >
                {t("menu.main.upov_classes")}
              </NavLink>
              <NavLink
                className="nav-link"
                activeClassName="active"
                exact
                to="/registers"
              >
                {t("menu.main.registers")}
              </NavLink>
            </Nav>
            <Nav>
              <NavLink
                className="nav-link folder-icon"
                activeClassName="active"
                exact
                to="/myalerts"
              >
                {t("menu.user.my_alerts")}
              </NavLink>

              <NavLink
                className="nav-link folder-icon"
                activeClassName="active"
                exact
                to="/mytests"
              >
                {t("menu.user.my_tests")}
              </NavLink>

              <NavDropdown
                title={t("menu.user.my_searches")}
                className={["folder-icon", classes.customDropdown].join(" ")}
                id="saved-searches-dropdown"
              >
                {currentSearches}
              </NavDropdown>

              <NavDropdown
                title={userName}
                className="user-icon"
                id="account-dropdown"
              >
                <NavDropdown.Item
                  onClick={() => window.open(`help/${i18n.language}/About_variety_finder.html`, '_blank')}>
                  {t("menu.user_submenu.help")}
                  <FontAwesomeIcon
                    icon={["fas", "question-circle"]}
                    className={[
                      classAlignMiddle,
                      classFloatRight,
                      classes.userMenuIcon,
                    ].join(" ")}
                    color="#BFBFBF"
                  />
                </NavDropdown.Item>
                {isAdvanced() ?
                  <>
                    <NavDropdown.Divider />
                    <NavDropdown.Item
                      onClick={()=> downloadDatabase()}>
                      {t("menu.user_submenu.download_database")}
                      <FontAwesomeIcon
                        icon={["fas", "database"]}
                        className={[
                          classAlignMiddle,
                          classFloatRight,
                          classes.userMenuIcon,
                        ].join(" ")}
                        color="#BFBFBF"
                      />
                    </NavDropdown.Item>
                  </>
                : <></>}
                {contributor ? (
                  <>
                    <NavDropdown.Divider />
                    <NavDropdown.Item
                      onClick={() => history.push('/contributions')}>
                      {t("menu.user_submenu.upload_contribution")}
                      <FontAwesomeIcon
                        icon={["fas", "arrow-alt-circle-up"]}
                        className={[
                          classAlignMiddle,
                          classFloatRight,
                          classes.userMenuIcon,
                        ].join(" ")}
                        color="#BFBFBF"
                      />
                    </NavDropdown.Item>
                  </>
                ) : <></>}
                <NavDropdown.Divider />
                  <NavDropdown.Item
                    className="logout-link"
                    onClick={()=> logoutAndDeleteStorage(true)}>
                    {t("menu.user_submenu.log_out")}
                  <FontAwesomeIcon
                    icon={["fas", "sign-out-alt"]}
                    className={[
                      classAlignMiddle,
                      classFloatRight,
                      classes.userMenuIcon,
                    ].join(" ")}
                    color="#BFBFBF"
                  />
                </NavDropdown.Item>
              </NavDropdown>
              {props.notifications && props.notifications.length ? (
                <NavDropdown
                  data-count={props.notifications.length}
                  title={
                    <FontAwesomeIcon
                      icon={["fas", "bell"]}
                      style={{ width: "17px", height: "20px" }}
                      className={[classAlignMiddle, classes.userMenuIcon].join(
                        " "
                      )}
                      color="#000000"
                    />
                  }
                  id="notification-dropdown"
                  className={["bell-icon", classes.customDropdown].join(" ")}
                >
                  {notifications}
                </NavDropdown>
              ) : (
                <></>
              )}
              {languages.length > 1 ? (
                <NavDropdown title={i18n.language} id="language-dropdown">
                  {languages}
                </NavDropdown>
              ) : <></>}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
      {Object.keys(selectedSearch).length?<Redirect to={{pathname: APP_URLS.SEARCH_VARIETIES, state: selectedSearch}} />:<></>}
      <Modal show={modalState} centered onHide={() => setModalState(false)}>
        <Modal.Header>{t("alert")}</Modal.Header>
        <Modal.Body>
          {t("delete_saved_search_alert_message", {
            search_name: deleteSavedSearch?.searchName || " ",
          })}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            onClick={() => setModalState(false)}
          >
            {t("cancel")}
          </Button>
          <Button
            variant="primary"
            onClick={() => deleteSearchSubmit()}
            type="submit"
            className="float-right"
          >
            {t("confirm")}
          </Button>
        </Modal.Footer>
      </Modal>
      <CustomModal
        show={testModalState}
        onHide={() => setTestModalState(false)}
        size={"lg"}
      >
        <TestDataSheet notification_test_id={activeTestDataSheetId} hideNavigation={true} />
      </CustomModal>
    </>
  );
};

export interface ISavedSearch {
  isDefault: boolean;
  datatype: string;
  searchName: string;
  searchTerms: string;
}

const mapStateToProps = (state: any) => {
  return {
    savedSearches: state.savedSearches.items,
    notifications: state.notifications.items,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onInitSavedSearches: (savedSearches: any) =>
      dispatch(actions.setSavedSearches(savedSearches)),
    onSetDefaultSavedSearch: (savedSearch: ISavedSearch) =>
      dispatch(actions.setDefaultSavedSearch(savedSearch)),
    onRemoveSavedSearch: (savedSearch: ISavedSearch) =>
      dispatch(actions.removeSavedSearch(savedSearch)),
    onSelectSavedSearch: (savedSearch: ISavedSearch) =>
      dispatch(actions.selectSavedSearch(savedSearch)),
    onInitNotifications: (notifications: any) =>
      dispatch(actions.setNotifications(notifications)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
